import React from "react";
import { withTranslation } from 'react-i18next';
import HandleErrorsMessage from "../../pages/Completion/HandleErrorsMessage";
import handleCondition from "./generateForm/handleConditionOnQuestion";
import { getQuestionRender, initResponse } from "./generateForm/questionRender";
import generateYupObject from "./generateForm/yupObject";
import { FieldGroup, Fieldset } from "../../components/catalyst-component/fieldset";
import { Text } from "../../components/catalyst-component/text";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import LoadingSpinner from "../../components/Animation/LoadingSpinner";

class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorsAPI: [],
            errors: [],
            form: null,
            formData: {},
            conditionInTheForm: [],
            pressSubmitOnce: false,
            submitOnLoading: false,
            loading: true,
            questionPaybox: false,
            questionPayboxshow: false
        }
        this.generateYupObject = generateYupObject.bind(this);
        this.getQuestionRender = getQuestionRender.bind(this);
        this.initResponse = initResponse.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
    }

    componentDidMount() {
        this.initForm();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.form !== this.props.form) {
            this.initForm();
        }
        if (prevProps.currentStep !== this.props.currentStep) {
            this.setState({ errorsAPI: [], errors: [], pressSubmitOnce: null, submitOnLoading: false });
        }
    }

    initForm() {
        this.setState({ loading: true });
        let form = Object.assign([], this.props.form);
        form = form.filter(q => q.fieldType !== "custom input" || q.object === "Logic")
        var formDataLoc = {};
        var conditionInTheForm = [];
        for (var index = 0; index < form.length; index++) {
            var question = form[index];
            if (question) {
                var questionName = question.name
                if (question.conditional && question.conditionalList) {
                    for (var clIndex in question.conditionalList) {
                        var cl = question.conditionalList[clIndex]
                        var name = null
                        if (cl && cl?.block !== "") {
                            // eslint-disable-next-line no-loop-func
                            name = form.find(q => q.id === cl?.block)?.name
                        } else {
                            cl.block = question.id
                        }
                        for (var sInd in cl?.subs) {
                            var s = cl?.subs[sInd];
                            if (cl) {
                                conditionInTheForm.push({
                                    parent: name ? name : questionName,
                                    question: s,
                                    condition: cl
                                })
                            }
                        }
                    }
                }
                if (question.sub) {
                    var parentG = form?.find(q => q.id === question.sub);
                    if (parentG) {
                        if (parentG.fieldType === "custom input" || parentG.fieldType === "custom variable") {
                            var parentsG = form?.filter(q => parentG.conditionalList?.find(c => c?.block === q.id))
                            for (var pIndex in parentsG) {
                                if (parentsG.conditionalList?.find(c => c?.block === question.id)) {
                                    conditionInTheForm.push({
                                        parent: parentsG[pIndex].name,
                                        question: question.id,
                                        condition: parentsG.conditionalList?.find(c => c?.block === question.id)
                                    })
                                }
                            }
                        } else {
                            if (!conditionInTheForm.find(c => c.parent === parentG.name && c.question === question.id)) {
                                conditionInTheForm.push({
                                    parent: parentG.name,
                                    question: question.id,
                                    condition: {}
                                })
                            }
                        }
                    }

                }

            }
        }
        formDataLoc = this.handleDataChange({}, true)
        if (form && formDataLoc) {
            this.schema = this.generateYupObject(form, formDataLoc, this.props.t);
        }
        this.setState({ conditionInTheForm })
        this.setState({ form: this.props.form }, () => { this.setState({ formData: formDataLoc, loading: false }) });
    }

    stepquestionpayboxshows(form, formData) {
        var isquestionpaybox = false;
        var isquestionpayboxshow = false;
        if (form && form.length) {
            for (var index = 0; index < form.length; index++) {
                var question = form[index];
                if (question) {
                    if (question.fieldType === "custom input" && question.label === "Paybox") {
                        isquestionpaybox = true;
                        if (handleCondition(formData, question, form)) {
                            isquestionpayboxshow = question;
                        }
                    }
                }
            }
        }
        return { isquestionpaybox, isquestionpayboxshow };
    }

    onDataChange(formData, currentQuestion) {
        const that = this;
        if (that.state.conditionInTheForm && that.state.conditionInTheForm.find(c => c.parent === currentQuestion.name || c?.condition?.and?.block === currentQuestion.id)) {
            var form = Object.assign([], that.props.form);
            that.schema = null;
            var locFormData = that.handleDataChange(formData)
            that.schema = that.generateYupObject(form, locFormData, this.props.t);
            that.setState({ formData: locFormData });
        } else {
            this.setState({ formData })
        }
        if (currentQuestion.required && that.state.pressSubmitOnce) {
            that.schema.validate(that.state.formData, { abortEarly: false })
                .catch(function (err) {
                    return err;
                })
                .then(err => { that.setState({ errors: err, formData }) });
        }
    }

    handleDataChange(formData, init = false) {
        var form = Object.assign([], this.props.form);
        form.forEach(q => {
            if (handleCondition(formData, q, this.props.form)) {
                if (q.fieldType === "custom variable") {
                    formData[q.name] = q.value;
                } else if (q.fieldType === "custom input") {
                    if (init && q.object === "Address" && q.options && q.options.length) {
                        q.options.forEach(o => {
                            if (o.value) {
                                var questionAdd = form.find(qAd => qAd.id === o.value);
                                formData[questionAdd.name] = questionAdd.value || "";
                            }
                        })
                    }
                }
            }
        })

        form = form.filter(q => q.fieldType !== "custom variable" && (q.fieldType !== "custom input" || q.object === "Address"))
        if (form && form.length) {
            for (var index = 0; index < form.length; index++) {
                var question = form[index];
                if (handleCondition(formData, question, this.props.form)) {
                    var formDataPart = this.handleQuestionValueChange(formData, question);
                    for (let indexKey = 0; indexKey < Object.keys(formDataPart).length; indexKey++) {
                        var key = Object.keys(formDataPart)[indexKey];
                        formData[key] = formDataPart[key];
                    }
                }

            }
        }
        var { isquestionpaybox, isquestionpayboxshow } = this.stepquestionpayboxshows(this.props.form, formData)
        this.setState({ questionPaybox: isquestionpaybox, questionPayboxshow: isquestionpayboxshow })
        return formData;
    }

    handleQuestionValueChange(formData, question) {
        if (!handleCondition(formData, question, this.props.form) && !(this.props.form.find(q => q.id !== question.id && q.name === question.name && handleCondition(formData, q, this.props.form)))) {
            formData[question.name] = "";
        } else {
            if (!formData[question.name] && formData[question.name] !== "" && formData[question.name] !== 0) {
                var initValue = this.initResponse(question);
                if (initValue !== null) {
                    formData[question.name] = initValue;
                }
            }
        }
        return formData;
    }

    handleSubmitForm() {
        this.props.toTheTop()
        if (!this.state.submitOnLoading) {
            this.setState({ submitOnLoading: true });
            this.setState({ pressSubmitOnce: true });
            this.setState({ errors: null })
            const that = this;
            if (this.props.form.find(f => f.fieldType !== "custom input" && f.fieldType !== "custom variable")) {
                const formData = that.state.formData;
                that.schema.isValid(formData).then(valid => {
                    if (valid) {
                        this.props.handleSubmit(formData).then(res => {
                            if (res) {
                                that.setState({ submitOnLoading: false, pressSubmitOnce: null });
                                that.props.toTheTop()
                            }
                        }).catch(() => {
                            that.props.toTheTop()
                            that.setState({ submitOnLoading: false });
                        });
                    }
                    else {
                        that.schema.validate(formData, { abortEarly: false })
                            .catch(function (err) {
                                return err;
                            })
                            .then(err => {
                                that.setState({ errors: err, submitOnLoading: false })
                            });
                    }
                });
            } else {
                this.props.handleSubmit({}).then(res => {
                    if (res) {
                        that.setState({ submitOnLoading: false, pressSubmitOnce: null });
                        that.props.toTheTop()
                    }
                }).catch(() => {
                    that.props.toTheTop()
                    that.setState({ submitOnLoading: false });
                });
            }
        }
    }

    render() {
        const { t } = this.props;
        return (<>{this.state.loading ? <></> :
            <form className="relative">
                <Fieldset className="main" >
                    <HandleErrorsMessage errors={this.state.errorsAPI && this.state.errorsAPI.length > 0 ? this.state.errorsAPI : (this.state.errors?.errors?.length > 0 ? [t("Veuillez corriger les erreurs de votre formulaire avant de soumettre.")] : null)} />
                    <div className="pb-5 gap-2" key="questionsrender">
                        <FieldGroup>
                            <div>
                                {this.state.form && this.state.form.length ? (
                                    this.state.form.map((question, key) => {
                                        return this.getQuestionRender(question, key);
                                    })
                                ) : null
                                }
                                <div key="submitform mt-7">
                                    <div className="flex items-center gap-4" style={this.props.amountSteps && this.props.amountSteps > this.props.currentStep && this.props.currentStep > 0 && this.props.back ? { justifyContent: "space-between" } : { justifyContent: "flex-end" }}>
                                        {this.props.amountSteps && this.props.amountSteps > this.props.currentStep && this.props.currentStep > 0 && this.props.back ?
                                            <Text
                                                className="cursor-pointer xl:block"
                                                onClick={() => {
                                                    this.setState({ errorsAPI: [], pressSubmitOnce: null, submitOnLoading: false });//?? pas apeller
                                                    this.props.setStep(this.props.currentStep - 1);
                                                }}
                                            >
                                                {t("Previous")}
                                            </Text>
                                            : null
                                        }
                                        {!(this.state.questionPaybox && this.state.questionPayboxshow && !this.state.questionPayboxshow.value && this.state.questionPayboxshow.options?.find(opt => opt.label === "PBX_TOTAL" && opt.value !== "0")) ?
                                            <>
                                                <div className="xl:flex flex-col items-end gap-2 hidden">
                                                    <div className="flex w-full justify-end bottom-0  mt-5 left-0">

                                                        <div className="flex items-center btn-slide hover:text-white z-10 " onClick={() => this.handleSubmitForm()}>
                                                            <ArrowRightIcon className="h-8 w-8 rounded-full p-2 mr-2 text-white bg-primary-perso" aria-hidden="true" />
                                                            <div className="cursor-pointer text-base leading-4">
                                                                {this.props.loading === true ? <LoadingSpinner /> : (this.props.next === null ? t("Finish") : this.props.next === true ? t("Next") : t("Save"))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.props.next === false ?
                                                        <div className="text-xs text-gray-400 max-w-xs text-center">
                                                            {t("Les étapes suivantes ne sont pas accessibles pour le moment, veuillez enregistrer vos informations avant de quitter la page")}
                                                        </div> :
                                                        this.props.nextStepBack === false ?
                                                            <div className="text-xs text-gray-400 max-w-xs text-center">
                                                                {t("Vous ne pouvez pas revenir en arrière à l'étape suivante, veuillez vérifier vos informations avant de continuer")}
                                                            </div>
                                                            : null
                                                    }
                                                </div>

                                                <div className="flex flex-col items-end gap-2 xl:hidden">

                                                    <div className="flex w-full xl:justify-end bottom-0 left-0 mt-5 xl:hidden">

                                                        <div className="flex items-center justify-center  text-white  bg-primary-perso w-full  rounded-full cursor-pointer z-10 " onClick={() => this.handleSubmitForm()}>
                                                            <ArrowRightIcon className="hidden  h-8 w-8 rounded-full p-2 mr-2 text-white bg-primary-perso" aria-hidden="true" />
                                                            <div className="p-4 xl:py-0 text-base leading-4">
                                                                {this.props.loading === true ? <LoadingSpinner /> : (this.props.next === null ? t("Finish") : this.props.next === true ? t("Next") : t("Save"))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.props.next === false ?
                                                        <div className="text-xs text-gray-400 max-w-xs text-center">
                                                            {t("Les étapes suivantes ne sont pas accessibles pour le moment, veuillez enregistrer vos informations avant de quitter la page")}
                                                        </div> :
                                                        this.props.nextStepBack === false ?
                                                            <div className="text-xs text-gray-400 max-w-xs text-center">
                                                                {t("Vous ne pouvez pas revenir en arrière à l'étape suivante, veuillez vérifier vos informations avant de continuer")}
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </> : null}

                                    </div>
                                </div>
                            </div>

                        </FieldGroup>
                    </div>

                </Fieldset>
            </form>
        }</>);
    }

}

export default withTranslation()(Form);